import { Specifications } from "./Specifications";

export default Specifications;
